import { Injectable } from '@angular/core';

import currency from 'currency.js';

@Injectable({
  providedIn: 'root',
})
export class CurrencyHelperService {
  private readonly EURO: {
    symbol: string;
    decimal: string;
    separator: string;
  } = { symbol: '€', decimal: ',', separator: '.' };

  constructor() {}

  // Konvertiert einen String oder eine Zahl in ein currency.js-Objekt
  public toCurrency(value: string | number): currency {
    return currency(value, this.EURO);
  }

  // Formatiert den currency-Wert als String
  public format(value: string | number): string {
    return this.toCurrency(value).format();
  }

  // Formatiert den currency-Wert mit einem Währungssymbol
  public formatWithCurrency(
    value: string | number,
    currencySign: string = '€ ',
  ): string {
    return this.toCurrency(value).format({
      symbol: `${currencySign} `,
    });
  }

  // Gibt den numerischen Wert (als Zahl) zurück, der im currency.js-Objekt gespeichert ist
  public getNumericValue(value: string | number): number {
    return this.toCurrency(value).value;
  }

  // Berechnet den Steuerbetrag und gibt den formatierten Betrag zurück
  public calculateTax(value: string | number, taxRate: number): string {
    const taxAmount = this.toCurrency(value).multiply(taxRate / 100);

    return this.format(taxAmount.value);
  }

  // Führt eine Addition von zwei Werten durch
  public add(value1: string | number, value2: string | number): string {
    return this.toCurrency(value1).add(value2).format();
  }

  // Führt eine Subtraktion von zwei Werten durch
  public subtract(value1: string | number, value2: string | number): string {
    return this.toCurrency(value1).subtract(value2).format();
  }

  // Führt eine Multiplikation eines Wertes mit einem Faktor durch
  public multiply(value: string | number, multiplier: number): string {
    return this.toCurrency(value).multiply(multiplier).format();
  }

  // Führt eine Division eines Wertes durch
  public divide(value: string | number, divisor: number): string {
    return this.toCurrency(value).divide(divisor).format();
  }
}
